import { render, staticRenderFns } from "./ModelRegister.vue?vue&type=template&id=6d1fcfbd&scoped=true&"
import script from "./ModelRegister.vue?vue&type=script&lang=js&"
export * from "./ModelRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1fcfbd",
  null
  
)

export default component.exports